var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c0a110408eac6694c98b2dc34689f062d53f41c6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["onbridge-dapp@delta-labs"]={id:"c0a110408eac6694c98b2dc34689f062d53f41c6"};
      